import { useEffect } from 'react'
import './location-map-image-block.component.css'
import { gsap } from 'gsap'
import useCheckForMobileHook from '../../../hooks/useCheckForMobile'
import { Loader } from '@googlemaps/js-api-loader'

const LocationMapImageBlockComponent = (props) => {
  const { restaurant, disableFullBleed } = props
  const isMobile = useCheckForMobileHook()
  const className = disableFullBleed
    ? 'prg-location-map-image-block-container'
    : 'prg-location-map-image-block-full'

  // Animation
  useEffect(() => {
    if (isMobile || restaurant.styles.disableParallax) return

    const scrollParams = {
      once: true,
      trigger: '.prg-location-map-image-block',
      start: 'top 50%',
      end: 'bottom 50%',
      scrub: 1,
    }

    setTimeout(() => {
      gsap.fromTo(
        '.prg-location-map-image-block #prg-location-map-display',
        {
          yPercent: 10,
          opacity: 0,
        },
        {
          yPercent: 0,
          opacity: 1,
          scrollTrigger: scrollParams,
        },
      )
    }, 250)
  }, [isMobile, restaurant.styles])

  // Create map on load
  useEffect(() => {
    const createMap = async () => {
      const { selectedLocation, styles, googleMaps } = restaurant
      const { apiKey, mapId, markerImage } = googleMaps

      if (!selectedLocation || !selectedLocation.googleMaps) return

      const loader = new Loader({
        apiKey,
        version: 'weekly',
      })

      const { Map, InfoWindow } = await loader.importLibrary('maps')
      const { AdvancedMarkerElement, PinElement } = await loader.importLibrary(
        'marker',
      )

      const { lat, long } = selectedLocation.googleMaps
      const position = { lat: parseFloat(lat), lng: parseFloat(long) }
      const map = new Map(document.getElementById('prg-location-map-display'), {
        center: position,
        zoom: 16,
        mapId,
      })

      const glyph = document.createElement('img')
      glyph.src = markerImage.url

      const mapPinBg = styles.mapPinColor || styles.primaryColor
      const pin = new PinElement({
        glyph,
        scale: 3,
        background: mapPinBg,
        borderColor: mapPinBg,
      })

      const marker = new AdvancedMarkerElement({
        map,
        position,
        title: selectedLocation.name,
        content: pin.element,
      })

      const infoWindow = new InfoWindow()

      marker.addListener('click', () => {
        infoWindow.close()
        infoWindow.setContent(
          `${marker.title}<br />${selectedLocation.address}`,
        )
        infoWindow.open(marker.map, marker)
      })
    }

    setTimeout(createMap, 100)
  }, [restaurant])

  return (
    <div className="prg-location-map-image-block">
      <div className={className}>
        <div id="prg-location-map-display" />
      </div>
    </div>
  )
}

export default LocationMapImageBlockComponent
